import script from "./VTCandles.vue?vue&type=script&lang=js"
export * from "./VTCandles.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__